<template>
    <span>
        <b-button
            class="align-baseline mr-1"
            title="Generate new iCal URL"
            variant="default"
            @click="onShowGenerateUrlModal"
        >
            <font-awesome-icon :icon="['fas', 'lock']"></font-awesome-icon>
        </b-button>
        <b-button
            class="align-baseline"
            title="Import iCal Data Manually"
            variant="default"
            @click="onShowSyncCalUrlModal"
            :disabled="this.params.data.ecallinks && !this.params.data.ecallinks.length"
        >
            <font-awesome-icon :icon="['fas', 'right-left']"></font-awesome-icon>
        </b-button>
        <modal
            v-if="generateUrlModalId"
            :id="generateUrlModalId"
            title="Generate New URL"
            ok-title="Continue"
            @ok="generateUrl"
        >
            Are you sure you want to generate a new iCal URL for "{{ this.params.data.name }}"? Current URL will stop
            working and this action cannot be reversed.
        </modal>
        <modal v-if="syncCalModalId" :id="syncCalModalId" title="Sync Calendar" @ok="syncCalendar">
            Are you sure you want to fetch blocks from external calendars for this property? This task will run in the
            background.
        </modal>
    </span>
</template>

<script>
    import { mapGetters } from 'vuex';
    import API from '../../api';
    import ResponsiveButton from '../generic/responsive-button/responsive-button.vue';
    import Modal from '../generic/modal/modal.vue';
    import { ICALENDAR_GENERATE_ICAL_URL_ENDPOINT } from '../../endpoints';

    export default {
        components: {
            ResponsiveButton,
            Modal,
        },
        data() {
            return {
                generateUrlModalId: null,
                syncCalModalId: null,
            };
        },
        computed: {
            ...mapGetters('iCalendar', ['websocket_token']),
        },
        methods: {
            onShowGenerateUrlModal() {
                this.generateUrlModalId = 'generate' + this.params.data.id.toString();
                this.$nextTick(() => {
                    this.$bvModal.show(this.generateUrlModalId);
                });
            },
            onShowSyncCalUrlModal() {
                this.syncCalModalId = 'sync' + this.params.data.id.toString();
                this.$nextTick(() => {
                    this.$bvModal.show(this.syncCalModalId);
                });
            },
            async generateUrl() {
                try {
                    await API.post(ICALENDAR_GENERATE_ICAL_URL_ENDPOINT(this.params.data.id.toString()), {});
                    await this.$store.dispatch('iCalendar/fetchUrls');
                    this.successToast({ text: `New iCal URL sucessfully generated ...` });
                } catch (e) {
                    this.errorToast({ text: `Could not generate url.` });
                }
            },
            async syncCalendar() {
                try {
                    await this.$store.dispatch('iCalendar/syncCalendarById', this.params.data.id.toString());
                    await this.$store.dispatch('iCalendar/fetchUrls');
                    this.successToast({ text: `Calendar(s) are now importing in the background ...` });
                } catch (e) {
                    this.errorToast({ text: `Could not import calendar(s).` });
                }
            },
        },
    };
</script>
